import { Button, Card, CardContent, Input, Label, Textarea } from "@repo/ui";

export default function Contact() {
  return (
    <section className="max-w-3xl mx-auto px-4 py-12 space-y-6">
      <h1 className="text-3xl font-semibold tracking-tight">Contact Us</h1>
      <Card>
        <CardContent className="p-6 space-y-4">
          <div className="grid gap-2">
            <Label>Name</Label>
            <Input placeholder="Your name" />
          </div>
          <div className="grid gap-2">
            <Label>Email</Label>
            <Input placeholder="you@example.com" type="email" />
          </div>
          <div className="grid gap-2">
            <Label>Message</Label>
            <Textarea placeholder="How can we help?" rows={5} />
          </div>
          <div className="flex items-center gap-3">
            <Button>Send</Button>
            <Button variant="outline" asChild>
              <a href="https://line.me/R/ti/p/@manoglamping" target="_blank" rel="noreferrer">
                Message on LINE
              </a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </section>
  );
}
